import {
  ArpMedia,
  ArpMediaNotificationModel,
  ArpMediaStatistics,
  ArpMediaSubType,
  ArpMediaType,
  InstrumentCategory,
  PaginatedResponse,
  PaginationParams,
  QueryParams
} from '@arpeggi/shared'
import { silentAuthenticatedGet, useAuth } from '../../hooks/useAuth'
import axios from '../../lib/axios'

export type Parts = Array<keyof Pick<ArpMedia, 'subComponents' | 'favoriteCount'>>

export interface GetArpMediaParams
  extends PaginationParams<
    Omit<ArpMedia, 'user' | 'subComponents' | 'metadata'> & { title: string }
  > {
  search?: string
  featured?: boolean
  tokenId?: number
  key?: number
  genre?: string[]
  type?: ArpMediaType[]
  subType?: ArpMediaSubType[]
  tag?: string[]
  ids?: number[]
  excludeIds?: number[]
  instrumentCategory?: InstrumentCategory
  subComponentId?: number[]
  walletAddress?: string
  isBlocklist?: boolean
  shadowBlocklist?: boolean
  isDefaultSample?: boolean
  samplePackId?: number
  [QueryParams.PARTS]?: Parts
}

export interface GetArpMediaNotificationsParams
  extends PaginationParams<Omit<ArpMediaNotificationModel, 'data'>> {}

export interface UpdateArpMediaDto {
  isBlocklist?: boolean
  isDefaultSample?: boolean
}

export const getArpMedia = async (params?: GetArpMediaParams) => {
  const { data } = await silentAuthenticatedGet<PaginatedResponse<ArpMedia>>(
    '/api/v2/arp-media',
    params
  )

  return data
}

export const getArpMediaStatistics = async () => {
  const { data } = await axios.get<ArpMediaStatistics>('/api/v2/arp-media/statistics')

  return data
}

// TODO swap this our for /arp-media?subComponent=<id>
export const getArpMediaParentComponents = async (id: number) => {
  const { data } = await axios.get<{ id: number; type: string }[]>(
    '/api/v2/arp-media/parent-components',
    { params: { subComponentId: id } }
  )

  return data
}

export const getOneArpMedia = async (id: number | string, params?: { parts?: Parts }) => {
  const { data } = await axios.get<ArpMedia>(`/api/v2/arp-media/${id}`, { params })

  return data
}

export const getArpMediaNotifications = async (
  id: number,
  params?: GetArpMediaNotificationsParams
) => {
  const { data } = await axios.get<PaginatedResponse<ArpMediaNotificationModel>>(
    `/api/v2/arp-media/${id}/notifications`,
    { params }
  )

  return data
}

export const useArpMediaAPI = () => {
  const { authenticatedPatch } = useAuth()

  const updateArpMedia = async (id: number, dto: UpdateArpMediaDto) => {
    const { data } = await authenticatedPatch<ArpMediaStatistics>(`/api/v2/arp-media/${id}`, dto)

    return data
  }

  return { updateArpMedia }
}
